import { DxOperations } from '../dx-types';

export type SortOrder = 'asc' | 'desc';

export enum Operator {
	Between = 'between',
	Contains = 'contains',
	NotContains = 'doesNotContain',
	Equals = 'equals',
	NotEquals = 'notEquals',
	LessThan = 'lessThan',
	GreaterThan = 'greaterThan',
	LessThanOrEqual = 'lessThanOrEqual',
	GreaterThanOrEqual = 'greaterThanOrEqual',
	In = 'in',
	NotIn = 'notIn',
	Specified = 'specified',
}

export class OperatorUtil {
	private static readonly OperatorMapping: Record<string, Operator> = {
		[DxOperations.Between]: Operator.Between,
		[DxOperations.Contains]: Operator.Contains,
		[DxOperations.NotContains]: Operator.NotContains,
		[DxOperations.Equal]: Operator.Equals,
		[DxOperations.NotEqual]: Operator.NotEquals,
		[DxOperations.LessThan]: Operator.LessThan,
		[DxOperations.GreaterThan]: Operator.GreaterThan,
		[DxOperations.LessThanOrEqual]: Operator.LessThanOrEqual,
		[DxOperations.GreaterThanOrEqual]: Operator.GreaterThanOrEqual,
		[DxOperations.In]: Operator.In,
		[DxOperations.NotIn]: Operator.NotIn,
	};

	public static getOperator(dxOp: DxOperations): Operator {
		return this.OperatorMapping[dxOp];
	}
}
